import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import FavNotificationsTile from './FavNotificationsTile';
import FavNotificationsTileEmpty from './FavNotificationsTileEmpty';
import { FAVORITES, FOLLOWING, ON_SALE, OFFER_MADE, ITEM_SOLD } from './favNotificationsConstants';
import { getNotificationsDisplayedTrackingObj } from './trackingHelpers.es';
import { showAlert } from './favNotificationsHelpers.es';
import FollowingsShownMutation from './FollowingsShown';
import style from './FavNotifications-style.scss';

let notificationsDisplayedTracked = false;

const followingsShown = ({ tiles, relay }) => {
    if (tiles.length) {
        FollowingsShownMutation.commit({
            environment: relay.environment,
            ids: tiles.map(({serviceId}) => serviceId)
        });
    }
};

const FavNotificationsTileList = props => {
    const { tiles, favoritesUrl, relay, hasNewEvents } = props;
    const hasFavorites = tiles.some(({type}) => type === FAVORITES);
    const hasFollowing = tiles.some(({type}) => type === FOLLOWING);

    if (!notificationsDisplayedTracked) {
        trackEvent(getNotificationsDisplayedTrackingObj({
            types: [
                { type: ON_SALE, displayed: tiles.some(({eventType}) => eventType === ON_SALE) },
                { type: OFFER_MADE, displayed: tiles.some(({eventType}) => eventType === OFFER_MADE) },
                { type: ITEM_SOLD, displayed: tiles.some(({eventType}) => eventType === ITEM_SOLD) },
                { type: FAVORITES, displayed: hasFavorites },
                { type: FOLLOWING, displayed: hasFollowing }
            ],
            hasNewEvents
        }));
        notificationsDisplayedTracked = true;
    }

    if (hasFollowing) {
        followingsShown({
            tiles: tiles.filter(tile => tile.type === FOLLOWING && showAlert(tile)),
            relay
        });
    }

    return (
        <div className={style.listContainer}>
            <div className={style.tileList}>
                {tiles.map(tile =>
                    <FavNotificationsTile key={tile.serviceId} tile={tile} favoritesUrl={favoritesUrl} />
                )}
                {!hasFavorites && <FavNotificationsTileEmpty type={FAVORITES} />}
                {!hasFollowing && <FavNotificationsTileEmpty type={FOLLOWING} />}
           </div>
       </div>
    );
};

FavNotificationsTileList.propTypes = {
    tiles: PropTypes.array.isRequired,
    favoritesUrl: PropTypes.string,
    relay: PropTypes.object,
    hasNewEvents: PropTypes.bool
};

export default createFragmentContainer(FavNotificationsTileList,
    {
        tiles: graphql`
            fragment FavNotificationsTileList_tiles on FavoriteNotification @relay(plural: true) {
                serviceId
                type
                eventType
                createdDate
                lastViewedDate
                ...FavNotificationsTile_tile
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTileList.jsx